<modal-panel id="filter-modal-panel" class="filter-modal-panel-cls filter-panel" [title]="'Filter'" (close)="handleClose()">
  <div id="filter-modal-div-1" class="filter" [formGroup]="form">
    <div id="filter-modal-div-2" class="filter__fields">
      <div class="filter__date-row">
        <mat-form-field class="filter__date-field">
          <mat-label id="filter-modal-from-label">From</mat-label>
          <input
            id="filter-modal-fromdp-input"
            matInput
            [matDatepicker]="fromDp"
            readonly
            formControlName="from">
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #fromDp id="filter-modal-from-date-datepicker"></mat-datepicker>
          <mat-datepicker-toggle matIconSuffix [for]="fromDp" id="filter-modal-datepicker-fromdp-toggle"></mat-datepicker-toggle>
        </mat-form-field>
        
        <mat-form-field class="filter__date-field">
          <mat-label id="filter-modal-to-label">To</mat-label>
          <input
            id="filter-modal-to-input"
            matInput
            [matDatepicker]="toDp"
            readonly
            [min]="fromDateControl.value"
            formControlName="to">
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker #toDp id="filter-modal-todp-datepicker"></mat-datepicker>
          <mat-datepicker-toggle matIconSuffix [for]="toDp" id="filter-modal-todp-datepickertoggle"></mat-datepicker-toggle>
        </mat-form-field>
      </div>
      
      <mat-form-field *ngIf="isLoggedInUserDirector" id="filter-modal-person-row">
        <mat-label id="filter-modal-person-label">Select Person</mat-label>
        <mat-select
          id="filter-modal-person-select"
          formControlName="email"
          (selectionChange)="onPersonSelection($event.value)">
          <mat-option
            *ngFor="let person of personList"
            [value]="person"
            [id]="'filter-modal-person-option-' + person.personId">
            {{person.firstName === 'All' && person.lastName === 'User' ? 'All User' : person.firstName + ' ' + person.lastName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <ng-container id="filter-modal-container" modalPanelFooter>
    <div class="modal-footer">
      <button id="filter-modal-button" mat-raised-button color="primary" (click)="apply()">APPLY</button>
    </div>
  </ng-container>
</modal-panel>
